import { BaseUrl } from './../const/index';
import axios, { AxiosRequestConfig, AxiosResponse, AxiosInstance } from 'axios';


// 创建 axios 实例
const instanceAPI = axios.create({
    baseURL: `${BaseUrl}`,
    timeout: 1000,
    headers: {'Cache-Control': 'no-cache',}
  });

// 设置统一的拦截器
function  interceptors(instance:AxiosInstance){
    instance.interceptors.request.use(async(reqConfig:AxiosRequestConfig)=>{
        // 在发送请求之前做些什么
        return Promise.resolve(reqConfig);
    },(err:any)=>{
        // 对请求错误做些什么
        return Promise.reject(err);
    });

    // 返回拦截器
    instance.interceptors.response.use(async(res:AxiosResponse)=>{
        return Promise.resolve(res.data);
    },(err:any)=>{
        return Promise.reject(err);
    })

    return instance
}

const API = interceptors(instanceAPI);
export default API